export const NOTIFICATION_CENTER_MOBILE_MAX_WIDTH_QUERY = "(max-width: 600px)"
export const NOTIFICATION_CENTER_TAB_KEYS = Object.freeze({
    RESERVATIONS: "reservations",
    ORDERS: "orders",
    ALERTS: "alerts",
    ANNOUNCEMENTS: "announcements",
});

export const NOTIFICATION_CENTER_TAB_COLORS = Object.freeze({
    PINK: "pink",
    GREEN: "green",
    BLUE: "blue",
    YELLOW: "yellow",
});
export const NOTIFICATION_CENTER_TAB_VISIBILITY = Object.freeze({
    ALWAYS: "always",
    SHOP_ONLY: "shop_only",
});

export const NOTIFICATION_CENTER_TAB_CONFIG = Object.freeze([
    {
        key: NOTIFICATION_CENTER_TAB_KEYS.RESERVATIONS,
        translationKey: "notification_center:tabs.reservations",
        iconName: "calendar outline",
        color: NOTIFICATION_CENTER_TAB_COLORS.PINK,
        visibility: NOTIFICATION_CENTER_TAB_VISIBILITY.ALWAYS,
        emptyState: {
            iconName: "calendar outline",
            titleKey: "notification_center:empty_states.reservations.title",
            descriptionKey: "notification_center:empty_states.reservations.description",
        },
    },
    {
        key: NOTIFICATION_CENTER_TAB_KEYS.ORDERS,
        translationKey: "notification_center:tabs.orders",
        iconName: "shopping basket",
        color: NOTIFICATION_CENTER_TAB_COLORS.GREEN,
        visibility: NOTIFICATION_CENTER_TAB_VISIBILITY.SHOP_ONLY,
        emptyState: {
            iconName: "shopping basket",
            titleKey: "notification_center:empty_states.orders.title",
            descriptionKey: "notification_center:empty_states.orders.description",
        },
    },
    {
        key: NOTIFICATION_CENTER_TAB_KEYS.ANNOUNCEMENTS,
        translationKey: "notification_center:tabs.announcements",
        iconName: "bullhorn",
        color: NOTIFICATION_CENTER_TAB_COLORS.BLUE,
        visibility: NOTIFICATION_CENTER_TAB_VISIBILITY.ALWAYS,
        emptyState: {
            iconName: "bullhorn",
            titleKey: "notification_center:empty_states.announcements.title",
            descriptionKey: "notification_center:empty_states.announcements.description",
        },
    },
    // {
    //     key: NOTIFICATION_CENTER_TAB_KEYS.ALERTS,
    //     translationKey: "notification_center:tabs.alerts",
    //     iconName: "warning sign",
    //     color: NOTIFICATION_CENTER_TAB_COLORS.YELLOW,
    //     visibility: NOTIFICATION_CENTER_TAB_VISIBILITY.ALWAYS,
    //     emptyState: {
    //         iconName: "warning sign",
    //         titleKey: "notification_center:empty_states.alerts.title",
    //         descriptionKey: "notification_center:empty_states.alerts.description",
    //     },
    // },
]);


// WEBPACK FOOTER //
// ./src/features/notification-center/constants/constants.js